(() => {
  if (customElements.get('whealth-launch-countdown')) return;
  class WhealthLaunchCountdown extends HTMLElement {
    static easternTime(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec((value || '').trim());
      if (!match) return NaN;
      const parts = match.slice(1).map(Number);
      const [year, month, day, hour, minute] = parts;
      if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return NaN;
      const target = Date.UTC(year, month - 1, day, hour, minute);
      const formatter = new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
      const localParts = (stamp) => Object.fromEntries(formatter.formatToParts(new Date(stamp)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
      let stamp = target;
      for (let i = 0; i < 4; i += 1) {
        const actual = localParts(stamp);
        const delta = target - Date.UTC(actual.year, actual.month - 1, actual.day, actual.hour, actual.minute);
        stamp += delta;
        if (!delta) break;
      }
      const actual = localParts(stamp);
      return actual.year === year && actual.month === month && actual.day === day && actual.hour === hour && actual.minute === minute ? stamp : NaN;
    }
    static phaseAt(now, launch, end) {
      if (!Number.isFinite(launch) || !Number.isFinite(end) || end <= launch || now >= end) return 'ended';
      return now < launch ? 'launch' : 'sale';
    }
    connectedCallback() {
      this.launch = WhealthLaunchCountdown.easternTime(this.dataset.launch);
      this.end = WhealthLaunchCountdown.easternTime(this.dataset.end);
      this.update();
      if (!this.hidden) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const now = Date.now();
      const phase = WhealthLaunchCountdown.phaseAt(now, this.launch, this.end);
      if (phase === 'ended') {this.hidden = true; clearInterval(this.interval); return;}
      const target = phase === 'launch' ? this.launch : this.end;
      if (this.phase !== phase) {
        this.phase = phase;
        this.dataset.phase = phase;
        this.querySelector('[data-countdown-title]').textContent = phase === 'launch' ? this.dataset.launchTitle : this.dataset.saleTitle;
        this.querySelector('[data-countdown-prefix]').textContent = phase === 'launch' ? this.dataset.launchPrefix : this.dataset.endPrefix;
        const date = this.querySelector('[data-countdown-date]');
        date.dateTime = new Date(target).toISOString();
        date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(new Date(target));
      }
      let remaining = Math.max(0, Math.ceil((target - now) / 1000));
      const days = Math.floor(remaining / 86400); remaining %= 86400;
      const hours = Math.floor(remaining / 3600); remaining %= 3600;
      const minutes = Math.floor(remaining / 60); const seconds = remaining % 60;
      Object.entries({days,hours,minutes,seconds}).forEach(([unit,value]) => {this.querySelector('[data-countdown-' + unit + ']').textContent = String(value).padStart(2,'0');});
      this.hidden = false;
    }
  }
  customElements.define('whealth-launch-countdown', WhealthLaunchCountdown);
})();
